export default {
  'nav.tours': 'Tour Packages',
  'nav.specialServices': 'Special Services',
  'nav.blog': 'Blog',
  'nav.about': 'About Us',
  'nav.whyUs': 'Why Us',
  'nav.contact': 'Contact',
  'nav.admin': 'Admin',
  'nav.adminPanel': 'Admin Panel',
  'nav.signIn': 'Sign In',
  'nav.myAccount': 'My Account',
  'nav.savedTours': 'Saved Tours',
  'nav.savedToursAria': 'Saved tours: {{count}}',
  'search.title': 'Search',
  'search.placeholder': 'Search tours, destinations, experiences, articles...',
  'search.close': 'Close search',
  'search.startTyping': 'Start typing to search the whole site',
  'search.noResults': 'No results found for "{{query}}"',
  'search.tours': 'Tour Packages',
  'search.destinations': 'Destinations',
  'search.experiences': 'Experiences',
  'search.blog': 'Blog',
  'search.viewAll': 'View all results',
  'search.popular': 'Popular suggestions',
  'footer.licensedVerified': 'Licensed & Verified',
  'footer.officialTourOperator': 'Official Tour Operator',
  'footer.company': 'Company',
  'footer.licenseNo': 'License No',
  'footer.headquarters': 'Headquarters',
  'footer.verified': 'Verified',
  'footer.licensed': 'Licensed',
  'footer.intlOperator': 'Intl. Operator',
  'footer.contact': 'Contact',
  'floating.callUs': 'Call Us',
  'floating.email': 'Email',
  'floating.whatsapp': 'WhatsApp',
  'floating.messenger': 'Messenger',
  'floating.chatInstantly': 'Chat instantly',
  'floating.fbChat': 'Facebook chat',
  'floating.quickContact': 'Quick contact',
  'floating.bookNow': 'Book Now',
  'footer.paymentMethods': 'Payment Methods',
  'footer.copyright': 'Copyright 2026 Vietnam.st - All rights reserved',
};